export default __webpack_public_path__ + "static/cover-lets-celebrate-667a5cacc990aaeb2f2ac86bc147c602.png";